import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2/icon';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {DEVICE_ICON_CLASS, DEVICE_LABEL_KEY} from '@FormMakerReact/layout/form-maker-canvas/form-maker-canvas.types';
import type {DeviceButtonProps} from './device-button.types';

export function DeviceButton({device, isActive, onSelect}: DeviceButtonProps): ReactElement {
  return (
    <Icon
      icon={DEVICE_ICON_CLASS[device]}
      shape={IconShape.CIRCLE}
      type={IconType.GHOST}
      size={IconSize.SIZE_ICON_20}
      isSelected={isActive}
      ariaLabel={window.i18next.t(DEVICE_LABEL_KEY[device])}
      onClick={(): void => {
        onSelect(device);
      }}
    />
  );
}
